import { render } from "./StationCard.vue?vue&type=template&id=5baa3c3b&scoped=true"
import script from "./StationCard.vue?vue&type=script&lang=js"
export * from "./StationCard.vue?vue&type=script&lang=js"

import "./StationCard.vue?vue&type=style&index=0&id=5baa3c3b&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baa3c3b"]])

export default __exports__